import React from "react";
import '../../App.css';
import { useEffect } from 'react';
import Footer from "../Footer";

export default function BookNow() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className="contact-container">
            <section className="contact-section">
                    <div className="contact-header">
                        <button className="enrichment-btn">Enrichment</button>
                        <h2>Roblock World Academy (Enrichment Classes)</h2>
                        <p>Need help registering for our classes? Don’t hesitate to reach out to us!</p>
                    </div>
                    <div className="contact-methods">
                        <div className="contact-card">
                            <div className="icon email-icon">
                                <i className="fa-solid fa-envelope icon-i"></i>
                            </div>
                            <h3>Email</h3>
                            <p><a href="mailto:roblockworld.sg@gmail.com">roblockworld.sg@gmail.com</a></p>
                        </div>
                        <div className="contact-card">
                            <div className="icon whatsapp-icon">
                                <i className="fa-brands fa-whatsapp icon-i"></i>
                            </div>
                            <h3>WhatsApp</h3>
                            <p><a href="https://wa.me/message/XCAPPOTEII6ML1" target="_blank">+65 9135 1633</a></p>
                            <p className="hours">(Operating Hours: 10am to 6pm)</p>
                        </div>
                        <div className="contact-card">
                            <div className="icon call-icon">
                                <i className="fa-solid fa-phone icon-i"></i>
                            </div>
                            <h3>Call</h3>
                            <p><a href="tel:+6591351633">+65 9135 1633</a></p>
                            <p className="hours">(Operating Hours: 10am to 6pm)</p>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </>
    )
}